// extracted by mini-css-extract-plugin
module.exports = {"dateWithText":"UpcomingLessonBadge_dateWithText__Dylwc","dateWrapper":"UpcomingLessonBadge_dateWrapper__Es3wF","startText":"UpcomingLessonBadge_startText__qF6Pr"};